export const CHECKOUT_URL = 'https://handball-class-ready.impultienda.ar/checkout';
export const STORE_URL = 'https://handball-class-ready.impultienda.ar';
export const TERMS_URL = 'https://handball-class-ready.impultienda.ar/#impu-legal-terms';
export const PRIVACY_URL = 'https://handball-class-ready.impultienda.ar/#impu-legal-privacy';
export const SUPPORT_EMAIL = 'support@stockdigital.shop';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
export const OFFER_ANCHOR = '#offer-details';

export const COVER_IMAGE =
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/29b0aff5-3e15-4f58-859e-017d981df68e/1792070892174_handball-page-01.webp';

export const DELIVERY_NOTE = 'Your download links are emailed after payment is approved.';
export const CHECKOUT_NOTE = 'Secure checkout. Final payment methods and currency are shown at checkout.';
export const GUARANTEE_TITLE = '10-Day Money-Back Guarantee';

export const heroInclusions = ['12 complete lessons', '40-page PDF guide', '5 bonuses', 'Ages 8–11'];

export const heroTrust: { icon: 'lock' | 'mail' | 'shield'; label: string }[] = [
  { icon: 'lock', label: 'Secure checkout' },
  { icon: 'mail', label: 'Download links by email' },
  { icon: 'shield', label: '10-day guarantee' },
];

export const trustStrip = [
  { value: 'PDF', label: 'Digital format' },
  { value: 'Email', label: 'Download links' },
  { value: 'One-time', label: '$27 USD payment' },
  { value: '10 days', label: 'Money-back guarantee' },
];

export const solutionStats = [
  { value: '12', label: 'Complete lessons' },
  { value: '40', label: 'Visual PDF pages' },
  { value: '40', label: 'Minutes per lesson' },
  { value: '5', label: 'Bonus resources' },
];

export const coreGuideFacts = [
  '40 visual pages',
  '12 complete 40-minute lessons',
  'Team handball for ages 8–11',
  'Soft balls, cones and marked targets',
  'No regulation court needed',
  'Adaptations for 30-, 40- and 50-minute lessons and different class sizes',
];

export const offerCoreInclusions = [
  '40-page visual PDF guide',
  '12 complete 40-minute lessons',
  'Court and station diagrams',
  'Timings and ready-to-say instructions',
  'Easier and harder options',
  'Observation points',
];

export const optionalExtras = ['Handball Class Ready — The Next 12 Lessons', '30 Small-Sided Handball Games'];

export const PREMIUM_MOCKUP_IMAGE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/29b0aff5-3e15-4f58-859e-017d981df68e/1792072669533_handball-premium-box-v1.webp';
